<template>
  <lila-login-template>
    <template #mainContent>
      <div
        v-if="unsubscribed"
        class="unsubscribe-newsletter full-width"
      >
        <h1 class="title">
          Pronto!
        </h1>

        <p class="bottom-gap">
          Seu e-mail foi removido da nossa lista de comunicações.
        </p>
      </div>

      <div
        v-else-if="!token"
        class="unsubscribe-newsletter full-width"
      >
        <h1 class="title">
          Link inválido
        </h1>

        <p class="bottom-gap">
          Este link de descadastramento está incompleto.
        </p>

        <p class="obs">
          Abra novamente o link que está no rodapé do e-mail que você recebeu.
          Se o problema continuar, entre em contato com a gente.
        </p>
      </div>

      <form
        v-else
        class="login-form unsubscribe-newsletter full-width"
        @submit.prevent="submitForm()"
      >
        <h1 class="title">
          Cancelar inscrição
        </h1>

        <lila-message :alert-data="alert" />

        <p class="bottom-gap">
          Sentiremos sua falta! Confirme abaixo para deixar de receber os
          comunicados da Lila Saúde.
        </p>

        <lila-textarea
          v-model="v.data.reason.$model"
          label="Motivo do descadastramento"
          placeholder="Conte pra gente o que motivou sua saída"
          :validation="v.data.reason"
        />

        <lila-button
          type="submit"
          title="Cancelar inscrição"
          class="submit-buttons"
          :is-centralized="true"
          :loading="loading"
        />
      </form>
    </template>
  </lila-login-template>
</template>

<script>
import axios from "axios";
import LoginTemplate from "@components/template/LoginTemplate.vue";
import Textarea from "@components/shared/fields/Textarea.vue";
import Button from "@components/shared/button/Button.vue";
import Message from "@components/shared/message/Message.vue";
import { maxLength } from "@vuelidate/validators";

// Function isolada (fora das APIs do portal) — não usa o $axios autenticado.
const unsubscribeUrl = process.env.VUE_APP_API_NEWSLETTER_UNSUBSCRIBE;

export default {
  components: {
    "lila-textarea": Textarea,
    "lila-button": Button,
    "lila-message": Message,
    "lila-login-template": LoginTemplate
  },
  data(){
    return {
      data: {
        reason: ""
      },
      token: "",
      alert: {
        message: "",
        type: "",
        show: false
      },
      loading: false,
      unsubscribed: false
    };
  },
  validations(){
    return {
      data: {
        reason: { maxLength: maxLength(500) }
      }
    };
  },
  created(){
    this.token = this.tokenFromQuery();
  },
  methods: {
    // O link enviado no e-mail traz um token opaco que o back resolve para o destinatário.
    tokenFromQuery(){
      const query = this.$route.query;
      const value = query.t || query.token || "";

      return typeof value === "string" ? value.trim() : "";
    },
    submitForm(){
      this.v.$touch();
      if(this.v.$invalid) return;

      this.loading = true;
      this.alert.show = false;

      axios
        .post(unsubscribeUrl, {
          "token": this.token,
          "reason": this.data.reason
        })
        .then(() => this.unsubscribed = true)
        .catch(() => {
          this.alert.type = "danger";
          this.alert.message = "Não foi possível cancelar sua inscrição agora. Tente novamente em alguns instantes.";
          this.alert.show = true;
        })
        .finally(() => this.loading = false);
    }
  }
};
</script>

<style>
    .unsubscribe-newsletter .textarea-component { margin-top: 20px; }
    .unsubscribe-newsletter .submit-buttons { margin-top: 40px; }
</style>
